// 引入中文语言包
import home from './home'
export default {
  ...home
}